import React from 'react'
import Featured from './Featured'
import Hero from './Hero'
import Signup from './Signup'

const Home = () => {
  return (
    <>
        <Hero/>
        <Featured/>
        <Signup/>
    </>
  )
}

export default Home